const baseRoute = "/user";

export const userRoutes = {
  DASHBOARD: `${baseRoute}/dashboard`,
  PAYMENT: `${baseRoute}/parent/payment`,
  PAYMENT_FEEDBACK: `${baseRoute}/parent/payment/feedback`,
  PROGRESS: `${baseRoute}/progressReport`,
};
